<script lang="ts">
    import ErpHorizontalTwoSplitLayout from 'src/features/erp/components/erp-split-layouts/ErpHorizontalTwoSplitLayout.svelte';
</script>

<ErpHorizontalTwoSplitLayout resizeDisabled pageClass="project-detail-reported-work-tab">
    <svelte:fragment slot="left-panel">
    </svelte:fragment>

    <svelte:fragment slot="right-panel">
    </svelte:fragment>
</ErpHorizontalTwoSplitLayout>